import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlGrupo = '/service/contabilidade/transparencia/grupoReceitas/'

class GruposContabeisService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getGruposContabeis(modelo) {
        let json = {
            modelo: modelo,
        }
        return this.conex.post(urlGrupo + 'grupoReceitas/', JSON.stringify(json))
    }
}
export default GruposContabeisService
